// Shared presentation helpers for the Command Center pages.

// Role → Badge variant + label. superadmin = green, admin = brand, viewer = neutral.
export const ROLE_BADGE = {
  superadmin: { variant: 'success', label: 'Super Admin' },
  admin: { variant: 'brand', label: 'Admin' },
  viewer: { variant: 'outline', label: 'Viewer' }
};

export function roleBadge(role) {
  return ROLE_BADGE[role] || { variant: 'default', label: role || 'Member' };
}

// Save action → Badge variant + label. import/rollback = amber, create = green.
export const ACTION_BADGE = {
  create: { variant: 'success', label: 'Created' },
  update: { variant: 'brand', label: 'Updated' },
  import: { variant: 'warning', label: 'Imported' },
  rollback: { variant: 'warning', label: 'Reactivated' },
  baseline: { variant: 'default', label: 'Baseline' },
  delete: { variant: 'danger', label: 'Deleted' },
  mixed: { variant: 'brand', label: 'Mixed' }
};

export function actionBadge(action) {
  return ACTION_BADGE[action] || { variant: 'default', label: action };
}

// Change type → Badge variant. added = green, removed = red, reactivated = amber.
export const CHANGE_TYPE_BADGE = {
  added: { variant: 'success', label: 'Added' },
  removed: { variant: 'danger', label: 'Removed' },
  changed: { variant: 'brand', label: 'Changed' },
  reactivated: { variant: 'warning', label: 'Reactivated' }
};

export function changeTypeBadge(type) {
  return CHANGE_TYPE_BADGE[type] || { variant: 'default', label: type };
}

// Gradient metric-tile accents, keyed by name.
export const METRIC_ACCENTS = {
  brand: 'from-brand-500 to-brand-700',
  emerald: 'from-emerald-500 to-emerald-700',
  amber: 'from-amber-500 to-amber-600',
  sky: 'from-sky-500 to-sky-700',
  violet: 'from-violet-500 to-violet-700',
  slate: 'from-slate-700 to-slate-900'
};

export function formatDate(value) {
  if (!value) return '—';
  return new Date(value).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
}

export function formatDateTime(value) {
  if (!value) return '—';
  return new Date(value).toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

// Compact relative time: "just now", "5m ago", "3h ago", "2d ago", else date.
export function relativeTime(value) {
  if (!value) return '—';
  const then = new Date(value).getTime();
  const diffMs = Date.now() - then;
  if (Number.isNaN(then)) return '—';
  if (diffMs < 0) return 'just now';

  const sec = Math.floor(diffMs / 1000);
  if (sec < 60) return 'just now';
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day}d ago`;
  return formatDate(value);
}

export function displayValue(value) {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}
